// extracted by mini-css-extract-plugin
module.exports = {"projects":"Projects_projects__1D38I","message":"Projects_message__QLi_Z"};